export const STATUS = {
  FAILED: false,
  SUCCESS: true,
  ALL: null,
};
